import { useAuth } from '../context/AuthContext';
import { colors } from './styles';

export default function UserBadge() {
  const { user, logout } = useAuth();
  if (!user) return null;

  const initials = (user.username || '?').slice(0, 2).toUpperCase();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '8px 10px', borderRadius: 10,
      background: 'rgba(91,110,232,0.08)',
      border: '1px solid rgba(91,110,232,0.18)',
    }}>
      {/* Avatar */}
      <div style={{
        width: 32, height: 32, borderRadius: 8, flexShrink: 0,
        background: `linear-gradient(135deg, ${colors.primary}, #8B5CF6)`,
        color: colors.white, display: 'flex', alignItems: 'center',
        justifyContent: 'center', fontSize: 12, fontWeight: 700,
        letterSpacing: '-0.2px',
      }}>
        {initials}
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 13, fontWeight: 600, color: colors.text,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {user.username}
        </div>
        <div style={{
          fontSize: 10, color: colors.navActiveText,
          textTransform: 'uppercase', letterSpacing: '0.6px',
        }}>
          {user.role || 'User'}
        </div>
      </div>

      {/* Logout */}
      <button
        onClick={logout}
        title="Sign out"
        style={{
          background: 'transparent', border: 'none',
          color: colors.textLight, cursor: 'pointer',
          fontSize: 14, padding: '4px 6px', borderRadius: 6,
          transition: 'color 0.15s ease',
          flexShrink: 0,
        }}
        onMouseEnter={e => e.currentTarget.style.color = colors.danger}
        onMouseLeave={e => e.currentTarget.style.color = colors.textLight}
      >
        ⏻
      </button>
    </div>
  );
}
